// extracted by mini-css-extract-plugin
module.exports =  {"globalizationChooser":"jut__GlobalizationChooser__globalizationChooser"};